namespace GeniuzPOS.Member {
    export enum PsMemberTypeSelectSellingPrice {
        SelectSellingPrice = 0,
        SelectSellingPrice1 = 1,
        SelectSellingPrice2 = 2,
        SelectSellingPrice3 = 3,
        SelectSellingPrice4 = 4,
        SelectSellingPrice5 = 5,
        SelectSellingPrice6 = 6
    }
    Serenity.Decorators.registerEnumType(PsMemberTypeSelectSellingPrice, 'GeniuzPOS.Member.PsMemberTypeSelectSellingPrice', 'Member.PsMemberTypeSelectSellingPrice');
}
